// src/App.js
import React from "react";
import Backdrop from "./components/Backdrop";
import FirewatchScene from "./components/FirewatchScene";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Projects from "./components/Projects";
import Contact from "./components/Contact";

import "@fortawesome/fontawesome-free/css/all.css";

const App = () => (
  <div className="text-white">
    {/* Continuous sky + 3D scene behind everything */}
    <Backdrop />
    <FirewatchScene />

    <div className="relative z-10">
      <Navbar />
      <main>
        <Hero />
        <About />
        <Projects />
        <Contact />
      </main>
    </div>
  </div>
);

export default App;
